import React, { useState } from 'react'
import PreviewPopupTable from './PreviewPopupTable';
import CommonLayout from '../CommonLayout';


const EditCategoryAction = ({prevData,newData}) => { 
   const [showPopup,setShowPopup] = useState(false);
   const [catData, setCatData] = useState({})
   const fieldsData = [
      {colKey:"field_name", colText:"Field Name"},
      {colKey:"category_name", colText:"Category Name"},
      {colKey:"description", colText:"Description"},
  ]

   
  const showPopupHanldel = (data) =>{
    setCatData(data)
    setShowPopup(true)
  }
    
  return <>
    {
      <CommonLayout 
        prevData={prevData}
        newData={newData}
        fieldsData={fieldsData}
        showPopupHanldel={showPopupHanldel}
      />
    }
    {showPopup && <PreviewPopupTable category={catData} hidePopup={()=>setShowPopup(false)}/>}
  </>;
}

export default EditCategoryAction